import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable, signal } from '@angular/core';
import { SERVICE_SETTINGS_SOCIAL_WORK_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsSocialWorkType,
} from '../../../../../modules/content/pages/services/settings/service-settings-social-work/service-settings-social-work.types';
import { offerPresenceOptions, offerTypeOptions } from '../social-service-select-offer.utils';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { offerDataFrag } from './social-service-select-offer-table.query';
import {
    SocialServiceOfferObject,
} from '@libs/types/src/services/object-type/service/social-service/social-service-offer.object';

@Injectable()
export class SocialServiceSelectOfferTableStore extends ComponentStoreV2Factory {

    public serviceId = signal(0);

    public settings = computed(() => this.globalGlobalStore.organizationStore.getServiceSetting<ServiceSettingsSocialWorkType>(this.serviceId(), SERVICE_SETTINGS_SOCIAL_WORK_KEY));

    public typeOptions = computed(() => offerTypeOptions(this.settings()));
    public presenceOptions = computed(() => offerPresenceOptions(this.settings()));

    public offerData = signal<Record<number, any>>({});

    public async fetchOffersData(_ids: number[]): Promise<void> {
        const ids = _ids.filter((id) => id && !(id in this.offerData()));
        if (!ids.length) return;

        const res = await this.api.getSocialServiceOffers(FilterBuilder.filter({ id: ids }), offerDataFrag);
        this.offerData.update((it) => {
            res.items?.forEach((ij: SocialServiceOfferObject) => {
                it[ij.id] = ij;
            });

            return { ...it };
        });
    }

}
